export default __webpack_public_path__ + "static/media/img-mindmap-body-mobile-new-2.df5197f1.jpg";